import clsx from 'clsx';
import React from 'react';

import { Container as StyledContainer } from './wrapper';

interface IProps {
  children: React.ReactNode;
  limitWidth?: boolean;
  inPanel?: boolean;
  style?: React.CSSProperties;
  yPadding?: 'p-y-md';
}

const Container = ({ children, limitWidth, inPanel, yPadding }: IProps) => (
  <StyledContainer className={clsx(limitWidth && 'limit-width', inPanel && 'in-panel', yPadding)}>
    {children}
  </StyledContainer>
);

export default Container;
